import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

import { Select2Data } from "../../../utils/common";

//Effect - Get All
export const AllCategory = createAsyncThunk(
  "common/categorys/all-category",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllCategory}?name=${filter}`);

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Product - Get All
export const AllProduct = createAsyncThunk(
  "common/categorys/all-product/:id",
  async ({ categoryId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllProduct}/${categoryId}?name=${name}`,
      );

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);


//Popular tag - Get All
export const AllPlatform = createAsyncThunk(
  "common/categorys/all-platform",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllPlatform}?name=${filter}`);

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Product Enquiry - Get All
export const AllProductEnquiry = createAsyncThunk(
  "common/product_enquirys/all-productenquiry/:id",
  async ({ productId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllProductEnquiry}/${productId}?name=${name}`,
      );

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Gallery Category
export const AllGalleryCategory = createAsyncThunk(
  "common/galleryshow/all-gallerycategory",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllGalleryCategory}?name=${filter}`,
      );

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Gallery Photo - Get All
export const AllGalleryPhoto = createAsyncThunk(
  "common/galleryshow/all-galleryphoto/:id",
  async ({ galcatId, question = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllGalleryPhoto}/${galcatId}?question=${question}`,
      );

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Why choose us - Get All
export const AllWhyChooseUs = createAsyncThunk(
  "common/aboutus/all-whychooseus",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllWhyChooseUs}?name=${filter}`);

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//App Setup - Get All
export const AllAppSetup = createAsyncThunk(
  "common/customizations/all-appsetup",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllAppSetup}?name=${filter}`);

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Contact Us - Get All
export const AllContactUs = createAsyncThunk(
  "common/contactuss/all-contactus",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllContactUs}?name=${filter}`);

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Country - Get All
export const AllCountry = createAsyncThunk(
  "common/masters/all-country",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllCountry}?name=${filter}`);

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));

      //return await Select2Data(res.data.data, "country_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// State - Get All (for a specific country)
export const AllState = createAsyncThunk(
  "common/masters/all-state/:id",
  async ({ countryId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllState}/${countryId}?name=${name}`,
      );

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//City - Get All (for a specific State)
export const AllCity = createAsyncThunk(
  "common/masters/all-city/:id",
  async ({ stateId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllCity}/${stateId}?name=${name}`);

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));

      // You can adjust Select2Data if necessary
      //return await Select2Data(res.data.data, "city_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Pincode - Get All (for a specific City)
export const AllPincode = createAsyncThunk(
  "common/masters/all-pincode/:id",
  async ({ cityId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllPincode}/${cityId}?name=${name}`,
      );

      // You can adjust Select2Data if necessary
      return await Select2Data(res.data.data, "pincode_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Privacy Policy - Get All
export const AllPrivacyPolicy = createAsyncThunk(
  "common/privacypolicys/all-privacypolicy",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllPrivacyPolicy}?name=${filter}`);

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Terms of service - Get All
export const AllTermsOfService = createAsyncThunk(
  "common/termsofservices/all-termsofservice",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllTermsOfService}?name=${filter}`);

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Total Effects dashboard - Get All
export const AllTotalEffects = createAsyncThunk(
  "common/dashboard/all-totaleffects",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllTotalEffects}?name=${filter}`);

      const rawData = res?.data?.data || {};

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Total Products dashboard - Get All
export const AllTotalProducts = createAsyncThunk(
  "common/dashboard/all-totalproducts",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllTotalProducts}?name=${filter}`);

      const rawData = res?.data?.data || {};

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Total Enquirys dashboard - Get All
export const AllTotalEnquirys = createAsyncThunk(
  "common/dashboard/all-totalenquirys",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllTotalEnquirys}?name=${filter}`);

      const rawData = res?.data?.data || {};

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Total Contacts dashboard - Get All
export const AllTotalContacts = createAsyncThunk(
  "common/dashboard/all-totalcontacts",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllTotalContacts}?name=${filter}`);

      const rawData = res?.data?.data || {};

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Slice = createSlice({
  name: "common",
  initialState: {
    all_country: [],
    all_state: [],
    all_city: [],
    all_pincode: [],

    all_whychooseus: [],

    all_appsetup: [],

    all_termsofservice: [],
    all_contactus: [],

    //category
    all_category: [],
    all_product: [],
    all_platform: [],
    all_productenquiry: [],
    all_gallerycategory: [],
    all_galleryphoto: [],
    all_totaleffects: 0,
    all_totalproducts: 0,
    all_totalenquirys: 0,
    all_totalcontacts: 0,
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all actions for GetSingle, Create, Update, Delete
      .addCase(AllCountry.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCountry.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_country = action.payload || [];
      })
      .addCase(AllCountry.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling AllState actions
      .addCase(AllState.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllState.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_state = action.payload || [];
      })
      .addCase(AllState.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling AllCity actions
      .addCase(AllCity.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCity.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_city = action.payload || [];
      })
      .addCase(AllCity.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling AllPincode actions
      .addCase(AllPincode.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllPincode.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_pincode = action.payload || [];
      })
      .addCase(AllPincode.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //Handle All Category actions
      .addCase(AllCategory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(AllCategory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_category = action.payload || [];
      })

      .addCase(AllCategory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })


      
      //Handle All Platform actions
      .addCase(AllPlatform.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(AllPlatform.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_platform = action.payload || [];
      })

      .addCase(AllPlatform.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling AllProduct actions
      .addCase(AllProduct.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllProduct.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_product = action.payload || [];
      })
      .addCase(AllProduct.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Product Enquiry
      .addCase(AllProductEnquiry.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(AllProductEnquiry.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_productenquiry = action.payload || [];
      })

      .addCase(AllProductEnquiry.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //Gallery category
      .addCase(AllGalleryCategory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllGalleryCategory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_gallerycategory = action.payload || [];
      })
      .addCase(AllGalleryCategory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling all actions for Gallery Photo
      .addCase(AllGalleryPhoto.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllGalleryPhoto.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_galleryphoto = action.payload || [];
      })
      .addCase(AllGalleryPhoto.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //Handle All why choose us actions
      .addCase(AllWhyChooseUs.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(AllWhyChooseUs.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_whychooseus = action.payload || [];
      })

      .addCase(AllWhyChooseUs.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //Handle All app setup actions
      .addCase(AllAppSetup.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(AllAppSetup.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_appsetup = action.payload || [];
      })

      .addCase(AllAppSetup.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //Handle All Privacy policy actions
      .addCase(AllPrivacyPolicy.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(AllPrivacyPolicy.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_privacypolicy = action.payload || [];
      })

      .addCase(AllPrivacyPolicy.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //Handle All terms of service actions
      .addCase(AllTermsOfService.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(AllTermsOfService.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_termsofservice = action.payload || [];
      })

      .addCase(AllTermsOfService.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handle All total effects actions
      .addCase(AllTotalEffects.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(AllTotalEffects.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_totaleffects = action.payload;
      })

      .addCase(AllTotalEffects.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handle All total Products actions
      .addCase(AllTotalProducts.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(AllTotalProducts.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_totalproducts = action.payload;
      })

      .addCase(AllTotalProducts.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handle All total enquirys actions
      .addCase(AllTotalEnquirys.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(AllTotalEnquirys.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_totalenquirys = action.payload;
      })

      .addCase(AllTotalEnquirys.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handle All total contacts actions
      .addCase(AllTotalContacts.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(AllTotalContacts.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_totalcontacts = action.payload;
      })

      .addCase(AllTotalContacts.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //Handle All Contact us actions
      .addCase(AllContactUs.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(AllContactUs.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_contactus = action.payload || [];
      })

      .addCase(AllContactUs.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
